import {variables} from "../config_variables/variables";

function buildEndpoint (url_suffix) {
      const dynamic_url = variables.base_url + url_suffix + "?code=" + variables.secret_code
      console.log('dynamic_url : '+ dynamic_url )
      return dynamic_url 
}

export default buildEndpoint